import React from 'react';
import styled from 'styled-components';
import { space, color, SpaceProps, ColorProps } from 'styled-system';

export const Section = styled.section`
  ${space}
  ${color}
` as React.FC<SpaceProps & ColorProps>;
